<template>
  <div>
    <h3>{{ parseTranslation(DELIMIT_NUMBER_OF_WORDS) }}</h3>

    <div class="number-of-word-wrapper">
      <div class="toggle-number-of-word">
        <div class="min-max-words">
          <span>{{ MIN_ACCEPTED_WORD }}</span>

          <span>{{ MAX_ACCEPTED_WORD }}</span>
        </div>

        <input
          type="range"
          v-model="numberOfWords"
          :min="MIN_ACCEPTED_WORD"
          :max="MAX_ACCEPTED_WORD"
        />
      </div>

      <input
        type="number"
        v-model="numberOfWords"
        :min="MIN_ACCEPTED_WORD"
        :max="MAX_ACCEPTED_WORD"
        @change="numberOfWordValidation"
      />

      <button class="apply" @click="setSettingsNumberOfWords">
        {{ parseTranslation(APPLY) }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import * as translationNumberOfWords from './numberOfWords.translations'

const { default: translations, ...translationKeys } = translationNumberOfWords

const DEFAULT_NUMBER_OF_WORDS = 50

export default {
  name: 'NumberOfWords',

  props: {
    question_result: {
      required: true,
      type: Object,
    },

    groupCode: {
      required: true,
    },
  },

  data() {
    return {
      numberOfWords: null,
      MIN_ACCEPTED_WORD: 1,
      MAX_ACCEPTED_WORD: null,
      translations,
      ...translationKeys,
    }
  },

  computed: {
    getNumberOfWords() {
      const numberOfWords = this.question_result?.chartSettings?.numberOfWords

      if (!numberOfWords && this.MAX_ACCEPTED_WORD < DEFAULT_NUMBER_OF_WORDS) {
        return this.MAX_ACCEPTED_WORD
      }

      return numberOfWords || DEFAULT_NUMBER_OF_WORDS
    },
  },

  watch: {
    getNumberOfWords() {
      this.numberOfWords = this.getNumberOfWords
    },
  },

  methods: {
    ...mapActions(['setChartSettings']),

    numberOfWordValidation() {
      if (this.numberOfWords < this.MIN_ACCEPTED_WORD) {
        this.numberOfWords = this.MIN_ACCEPTED_WORD
      }

      if (this.numberOfWords > this.MAX_ACCEPTED_WORD) {
        this.numberOfWords = this.MAX_ACCEPTED_WORD
      }
    },

    setSettingsNumberOfWords() {
      this.setChartSettings({
        setting: {
          ...this.question_result?.chartSettings,

          numberOfWords: Number(this.numberOfWords),
        },

        groupCode: this.groupCode,
        questionCode: this.question_result.code,
      })
    },
  },

  created() {
    this.MAX_ACCEPTED_WORD = this.question_result.results.length
    this.numberOfWords = this.getNumberOfWords
  },
}
</script>

<style lang="scss" scoped>
h3 {
  @include chart-config-title;
  margin-top: 10px;
  padding: 0 10px;
}

.number-of-word-wrapper {
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  max-width: 500px;
  width: 100%;

  input {
    margin-bottom: 20px;
    outline: none;
  }

  .toggle-number-of-word {
    .min-max-words {
      display: flex;
      justify-content: space-between;
      padding: 0 1px;
      margin-bottom: 5px;

      span {
        @include tipography(16);
        font-weight: bold;
        color: $blue;
      }
    }

    input[type='range'] {
      width: 100%;
      cursor: pointer;
    }
  }

  input[type='number'] {
    @include tipography(16);
    padding: 8px 10px;
    border: 1px solid #cacaca;
    border-radius: 3px;
    background: $gray-7;

    &:focus {
      transition: all 0.5s ease;
      box-shadow: 0px 0px 0px 2px rgba(0, 0, 0, 0.15);
    }

    .light & {
      color: $gray-6;
      background: $white;
    }
  }

  .apply {
    @include primary-general-button;
    @include tipography(14);
    margin-left: auto;
    width: 100px;
    padding: 8px 10px;
    letter-spacing: 0.1em;
  }
}
</style>
